import { theme as theme2 } from '@clubspark-react/ui';

import { makeStyles } from 'makeStyles';
import { themeV2 } from 'theme/themeV2';

export const useStyles = makeStyles()((theme) => ({
  button: {
    color: themeV2.colors.primary100main.value,
    fontSize: theme2.fontSizes.medium.value,
    fontWeight: theme2.fontWeights.bold.value,
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    justifyContent: 'space-between',
    border: 'none',
    padding: `${theme.spacing(1)} 0`,
    cursor: 'pointer',
    '& svg': {
      marginRight: theme.spacing(0.5),
      display: 'inline-flex',
      alignSelf: 'center',
      marginBottom: '1.2px',
    },
  },
}));

export default useStyles;
